import { SOCIAL_CHANNELS } from '../../constants/social'

export default function SocialSidebar() {
  return (
    <div className="fixed end-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2 lg:flex">
      {SOCIAL_CHANNELS.map(({ key, href, icon: Icon, label }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-primary text-white shadow-lg transition-transform hover:scale-110 hover:bg-secondary"
        >
          <Icon />
        </a>
      ))}
    </div>
  )
}
